import RulaBadge from '@pathccm/rula-ui/badge';
import RulaTooltip from '@pathccm/rula-ui/tooltip';
import Text from '@/components/Text';

export type ExpirationStatus = 'expired' | 'expiring';
interface AccountCardBadgeProps {
  expirationStatus: ExpirationStatus;
  haveEmail: boolean;
  patientUuid: string;
  onTransferClick: (uuid: string, cta_type: string) => void;
}

const AccountCardBadge: React.FC<AccountCardBadgeProps> = ({
  expirationStatus,
  haveEmail,
  patientUuid,
  onTransferClick,
}) => {
  const expiring = expirationStatus === 'expiring';
  const badgeText = expiring ? 'Expiring' : 'Expired';
  let tooltipText = expiring
    ? 'You will soon lose access as a result of this patient turning 18. Provide their email address for our records before their 18th birthday.'
    : 'Your access has expired because this patient has turned 18.';

  if (expiring && haveEmail) {
    tooltipText =
      'You will soon lose access because this patient is turning 18. On their 18th birthday, they will receive an email at their registered email address with instructions to complete their account setup.';
  }

  const iconColor = expiring ? '#CE1D1D' : '#3E2E73';

  return (
    <RulaBadge
      style={expiring ? 'Error' : 'Verified'}
      className="mx-auto mt-4 md:mr-4 md:mt-0"
    >
      <RulaTooltip iconColor={iconColor}>
        {tooltipText}
        {expiring && !haveEmail && (
          <>
            <br></br>
            <Text.P.Bold
              className="text-sky-50 underline cursor-pointer mt-2"
              role="button"
              onClick={() => onTransferClick(patientUuid, 'submit_email_<18')}
            >
              Submit email
            </Text.P.Bold>
          </>
        )}
      </RulaTooltip>
      {badgeText}
    </RulaBadge>
  );
};

export default AccountCardBadge;
